export default __webpack_public_path__ + "8b04f2f6a00bf65a2ebc69df5b77e330.png";